import { lazy, Suspense } from 'react';
import { AppShell } from '@mantine/core';
import { Route, Routes, useLocation } from 'react-router';
import { pageTitle } from '../../shared/routes.js';
import { Header } from './views/layout/header.jsx';
import { ProtectedRoute } from './views/layout/protected-route.jsx';
import { BillingDialogs } from './views/billing/billing-dialogs.jsx';
import { BillingSuccessPage } from './views/billing/billing-success-page.jsx';
import { Loading } from './views/feedback/loading.jsx';
import { HomePage } from './views/home/home-page.jsx';
import { SelectSitePage } from './views/account/select-site-page.jsx';
import { ProfilePage } from './views/account/profile-page.jsx';
import { AdminPage } from './views/account/admin-page.jsx';
import { ContactPage } from './views/contact/contact-page.jsx';
import { NotFoundPage } from './views/not-found/not-found-page.jsx';

const Dashboard = lazy(() => import('./views/dashboard/dashboard-page.jsx').then(module => ({ default: module.DashboardPage })));

export function App() {
  const { pathname } = useLocation();
  return <AppShell header={{ height: 72 }} padding={0}>
    <title>{`${pageTitle(pathname)} — Page Outil`}</title>
    <Header />
    <AppShell.Main><Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/setup" element={<ProtectedRoute><SelectSitePage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Suspense fallback={<Loading label="Loading dashboard…" />}><Dashboard /></Suspense></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
      <Route path="/billing/success" element={<ProtectedRoute><BillingSuccessPage /></ProtectedRoute>} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes></AppShell.Main>
    <BillingDialogs />
  </AppShell>;
}
